module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.65625,
						"dataLabels": {
							"enabled": true,
							"format": "2125"
						}
					},
					{
						"y": 93.61213235294117,
						"dataLabels": {
							"enabled": true,
							"format": "2037"
						}
					},
					{
						"y": 90.71691176470588,
						"dataLabels": {
							"enabled": true,
							"format": "1974"
						}
					},
					{
						"y": 84.19117647058823,
						"dataLabels": {
							"enabled": true,
							"format": "1832"
						}
					},
					{
						"y": 64.88970588235294,
						"dataLabels": {
							"enabled": true,
							"format": "1412"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.42033383915023,
						"dataLabels": {
							"enabled": true,
							"format": "642"
						}
					},
					{
						"y": 89.37784522003035,
						"dataLabels": {
							"enabled": true,
							"format": "589"
						}
					},
					{
						"y": 88.46737481031866,
						"dataLabels": {
							"enabled": true,
							"format": "583"
						}
					},
					{
						"y": 80.42488619119878,
						"dataLabels": {
							"enabled": true,
							"format": "530"
						}
					},
					{
						"y": 53.566009104704094,
						"dataLabels": {
							"enabled": true,
							"format": "353"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.01449275362319,
						"dataLabels": {
							"enabled": true,
							"format": "265"
						}
					},
					{
						"y": 90.21739130434783,
						"dataLabels": {
							"enabled": true,
							"format": "249"
						}
					},
					{
						"y": 86.23188405797102,
						"dataLabels": {
							"enabled": true,
							"format": "238"
						}
					},
					{
						"y": 74.27536231884058,
						"dataLabels": {
							"enabled": true,
							"format": "205"
						}
					},
					{
						"y": 40.94202898550724,
						"dataLabels": {
							"enabled": true,
							"format": "113"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.62522202486679,
						"dataLabels": {
							"enabled": true,
							"format": "4352"
						}
					},
					{
						"y": 88.36589698046181,
						"dataLabels": {
							"enabled": true,
							"format": "3980"
						}
					},
					{
						"y": 85.59058614564832,
						"dataLabels": {
							"enabled": true,
							"format": "3855"
						}
					},
					{
						"y": 80.21758436944938,
						"dataLabels": {
							"enabled": true,
							"format": "3613"
						}
					},
					{
						"y": 65.23090586145648,
						"dataLabels": {
							"enabled": true,
							"format": "2938"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.8021978021978,
						"dataLabels": {
							"enabled": true,
							"format": "1068"
						}
					},
					{
						"y": 96.06227106227107,
						"dataLabels": {
							"enabled": true,
							"format": "1049"
						}
					},
					{
						"y": 92.94871794871796,
						"dataLabels": {
							"enabled": true,
							"format": "1015"
						}
					},
					{
						"y": 86.53846153846155,
						"dataLabels": {
							"enabled": true,
							"format": "945"
						}
					},
					{
						"y": 60.34798534798534,
						"dataLabels": {
							"enabled": true,
							"format": "659"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.34375,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.141176470588237,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.0927835051546393,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.193515704153997,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.92576419213974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5796661608497695,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.255451713395633,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.018675721561968,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.39622641509435,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.985507246376807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.037735849056602,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.417670682730924,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.86554621848739,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -44.8780487804878,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.374777975133214,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.547794117647056,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.1407035175879394,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.277561608300908,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.682535289233325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.197802197802201,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.7790262172284632,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.241182078169691,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.26455026455026,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2176"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=659"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=276"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4504"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1092"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2176,
				2125,
				2037,
				1974,
				1832,
				1412
			],
			"Interior Health": [
				659,
				642,
				589,
				583,
				530,
				353
			],
			"Northern Health": [
				276,
				265,
				249,
				238,
				205,
				113
			],
			"Vancouver Coastal Health": [
				4504,
				4352,
				3980,
				3855,
				3613,
				2938
			],
			"Vancouver Island Health": [
				1092,
				1068,
				1049,
				1015,
				945,
				659
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 172
// module chunks = 0